export default __webpack_public_path__ + "static/media/horse1.fd2c1f36.jpg";